import React from 'react';
import ControlToggleGroup from './ControlToggleGroup';

export const PERIOD_TOGGLE_OPTIONS = [
  { value: 'oneMonth', tooltip: 'One Month', sublabel: '1M' },
  { value: 'threeMonths', tooltip: 'Three Months', sublabel: '3M' },
  { value: 'ytd', tooltip: 'Year to Date', sublabel: 'YTD' },
  { value: 'oneYear', tooltip: 'One Year', sublabel: '1Y' },
  { value: 'threeYears', tooltip: 'Three Years', sublabel: '3Y' },
  { value: 'fiveYears', tooltip: 'Five Years', sublabel: '5Y' },
  { value: 'tenYears', tooltip: 'Ten Years', sublabel: '10Y' },
];

function ControlPeriodToggle({
  context = 'filterBar',
  value,
  onChange,
  label = 'Time Frame',
  labelWidth = 50,
  buttonWidth = 32,
  ariaLabel = 'Time period',
}) {
  return (
    <ControlToggleGroup
      context={context}
      value={value}
      onChange={onChange}
      options={PERIOD_TOGGLE_OPTIONS}
      label={label}
      labelWidth={labelWidth}
      buttonWidth={buttonWidth}
      mode="text"
      ariaLabel={ariaLabel}
    />
  );
}

export default ControlPeriodToggle;
